import React from "react";
import { motion } from "framer-motion";
import "./ServicesPagecontent.css";

// WORK DATA (you can extend this anytime)
const works = [
    {
        title: "Hopkins Restorative",
        category: "Web Design",
        image: "/assets/work1.jpg",
    },
    {
        title: "Stride Branding",
        category: "Logo Design",
        image: "/assets/work2.jpg",
    },
    {
        title: "DJ Afro Caribbean",
        category: "Post Design",
        image: "/assets/work3.jpg",
    },
];

export default function ServicesPagecontent() {
    return (
        <section className="services-page">

            {/* HERO */}
            <div className="services-hero">
                <h1>DESIGN SERVICES<br />THAT BUILD BRANDS</h1>
                <p>Web Design · Logo Design · Social Media Posts</p>

                <div className="hero-actions">
                    <button className="primary-btn">Browse Packages</button>
                    <button className="ghost-btn">View Work</button>
                </div>
            </div>

            {/* SERVICES */}
            <div className="services-list">

                <ServiceBlock
                    tag="DIGITAL EXPERIENCE"
                    title="Web Design That Converts"
                    desc="High-performance websites engineered for clarity, speed, and trust."
                    items={[
                        "UI/UX Wireframing",
                        "Responsive Design",
                        "Conversion-Focused Layouts",
                        "Developer-Ready Files",
                    ]}
                />

                <ServiceBlock
                    tag="BRAND IDENTITY"
                    title="Logos That Speak Without Words"
                    desc="Timeless logo systems built to scale across platforms."
                    items={[
                        "Brand Discovery",
                        "Primary & Secondary Logos",
                        "Typography & Color System",
                        "Social Media Exports",
                    ]}
                />

                <ServiceBlock
                    tag="CONTENT DESIGN"
                    title="Scroll-Stopping Post Designs"
                    desc="Branded post designs optimized for engagement."
                    items={[
                        "Instagram & Facebook Posts",
                        "Carousel Designs",
                        "Editable Canva / PSD Files",
                        "Brand Consistency",
                    ]}
                />

            </div>

            {/* WORKS */}
            <div className="works-section">
                <h2>Selected Work</h2>

                <div className="works-grid">
                    {works.map((work, i) => (
                        <motion.div
                            key={i}
                            className="work-card"
                            whileHover={{ y: -8 }}
                        >
                            <img src={work.image} alt={work.title} />
                            <div className="work-info">
                                <h4>{work.title}</h4>
                                <span>{work.category}</span>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>

        </section>
    );
}

function ServiceBlock({ tag, title, desc, items }) {
    return (
        <motion.div
            className="service-block"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
        >
            <span className="service-tag">{tag}</span>
            <h3>{title}</h3>
            <p>{desc}</p>

            <ul>
                {items.map((item, i) => (
                    <li key={i}>{item}</li>
                ))}
            </ul>
        </motion.div>
    );
}
